exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MultiSelectFilterForm select {\n  width: 100%;\n  margin-top: 4px;\n}\n\n.MultiSelectFilterForm .Entry {\n  float: left;\n  border: solid 1px #669044;\n  border-radius: 3px;\n  font-size: 16px;\n  color: #669044;\n  width: -moz-fit-content;\n  width: fit-content;\n  padding: 8px 4px;\n  height: 34px;\n  line-height: 16px;\n  margin-right: 4px;\n  margin-bottom: 4px;\n}\n\n.MultiSelectFilterForm .Entry svg {\n  margin-left: 4px;\n  margin-top: -2px;\n}", ""]);

// exports
